import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/useT';

const COOKIE_CONSENT_KEY = 'dys_cookie_consent';

const mono = "'JetBrains Mono', monospace";
const ivory = '#f4f2ee';
const muted = 'rgba(232, 230, 224, 0.55)';

const CookieConsent: React.FC = () => {
    const t = useT();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);

        if (!consent) {
            const timer = setTimeout(() => setVisible(true), 1000);

            return () => clearTimeout(timer);
        }

        return undefined;
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label={t('cookie.title')}
            style={{
                position: 'fixed',
                bottom: 16,
                left: 16,
                right: 16,
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'none',
            }}
        >
            <div
                style={{
                    pointerEvents: 'auto',
                    width: '100%',
                    maxWidth: 720,
                    background: 'rgba(12, 11, 10, 0.96)',
                    border: '1px solid rgba(232, 230, 224, 0.12)',
                    borderRadius: 6,
                    padding: '18px 20px',
                    backdropFilter: 'blur(14px)',
                    WebkitBackdropFilter: 'blur(14px)',
                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.45)',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 16,
                    color: ivory,
                    fontFamily: "'Geist', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
            >
                <div style={{ flex: '1 1 320px', minWidth: 0 }}>
                    <div
                        style={{
                            fontSize: 10,
                            color: muted,
                            letterSpacing: '0.22em',
                            fontFamily: mono,
                            fontWeight: 500,
                            textTransform: 'uppercase',
                            marginBottom: 6,
                        }}
                    >
                        {t('cookie.title')}
                    </div>
                    <p style={{ fontSize: 13, lineHeight: 1.55, color: 'rgba(232, 230, 224, 0.78)', margin: 0 }}>
                        {t('cookie.text')}{' '}
                        <Link
                            to="/privacy"
                            style={{
                                color: ivory,
                                textDecoration: 'underline',
                                textUnderlineOffset: 2,
                            }}
                        >
                            {t('cookie.privacy')}
                        </Link>
                        .
                    </p>
                </div>

                <div style={{ display: 'flex', gap: 8, flexShrink: 0, marginLeft: 'auto' }}>
                    <button
                        type="button"
                        onClick={handleDecline}
                        style={{
                            background: 'transparent',
                            color: muted,
                            border: '1px solid rgba(232, 230, 224, 0.14)',
                            padding: '10px 16px',
                            borderRadius: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            cursor: 'pointer',
                            fontFamily: mono,
                            letterSpacing: '0.1em',
                            textTransform: 'uppercase',
                        }}
                    >
                        {t('cookie.decline')}
                    </button>
                    <button
                        type="button"
                        onClick={handleAccept}
                        style={{
                            background: ivory,
                            color: '#0a0a0a',
                            border: 'none',
                            padding: '10px 18px',
                            borderRadius: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            cursor: 'pointer',
                            fontFamily: mono,
                            letterSpacing: '0.1em',
                            textTransform: 'uppercase',
                        }}
                    >
                        {t('cookie.accept')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
